import { render, staticRenderFns } from "./ExpenseNew_Details.vue?vue&type=template&id=13b56ac4&"
import script from "./ExpenseNew_Details.vue?vue&type=script&lang=js&"
export * from "./ExpenseNew_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports